import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import MarketingPage from "./MarketingPage";
import { BrowserRouter } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import "./i18n/config.ts";
import { COLOR_MAIN } from "./utils/Colors";
import { LoadingView } from "./components/LoadingView";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Suspense fallback={<LoadingView minHeight="100vh" />}>
    <React.StrictMode>
      <BrowserRouter>
        <MarketingPage />
      </BrowserRouter>
    </React.StrictMode>
  </Suspense>
);
